
export class BaseService { 

    getAuthenticationToken() {
        return window.sessionStorage.getItem('auth-token');
    }

    getHeaders() {
        const headers:HeadersInit = {};
        const token =  this.getAuthenticationToken();
        if(token!=null) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        headers['Content-Type'] = 'application/json';
        headers['Accept'] = 'application/json';
        return headers;
    }
} 